export const TENANT_QUERY_KEYS = {
  all: ['tenants'] as const,
  list: ['tenants', 'list'] as const,
  detail: (id: string) => ['tenants', 'detail', id] as const,
  users: (id: string) => ['tenants', 'users', id] as const,
  notOnIdentity: ['tenants', 'not-on-identity'] as const,
  keptAdmins: ['tenants', 'kept-admins'] as const,
}
